import React, { Fragment } from 'react';
import { ToastContainer } from "react-toastify";

const Layout = ({ children }) => {
  return (
    <Fragment>
      <main className={'flex min-w-screen min-h-screen justify-center'}>
        {children}
      </main>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme={'colored'}
        limit={3}
      />
    </Fragment>
  );
}

export default Layout;
